var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        .st0{fill:currentColor;}\r\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_40_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    fill: "currentColor",
    d: "M20.4,4.9H17V3.1c0-1.3-1.1-2.4-2.4-2.4H9.5C8.1,0.7,7,1.8,7,3.1v1.8H3.6C1.6,4.9,0,6.5,0,8.5             v11.2c0,2,1.6,3.6,3.6,3.6h16.9c2,0,3.6-1.6,3.6-3.6V8.5C24,6.5,22.4,4.9,20.4,4.9L20.4,4.9z M8.5,3.1c0-0.5,0.4-1,1-1h5.1             c0.5,0,1,0.4,1,1v1.8H8.5L8.5,3.1z M1.4,19.7V8.5c0-0.9,0.6-1.8,1.5-2.1v15.3C2,21.5,1.4,20.7,1.4,19.7z M4.3,21.9V6.3h15.4v15.5             H4.3z M22.6,19.7c0,0.9-0.6,1.8-1.5,2.1V6.5c0.9,0.3,1.5,1.1,1.5,2.1V19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    fill: "currentColor",
    d: "M16.2,12h-2.1V9.9c0-0.4-0.3-0.7-0.7-0.7h-2.8c-0.4,0-0.7,0.3-0.7,0.7V12H7.8             c-0.4,0-0.7,0.3-0.7,0.7v2.8c0,0.4,0.3,0.7,0.7,0.7h2.1v2.1c0,0.4,0.3,0.7,0.7,0.7h2.8c0.4,0,0.7-0.3,0.7-0.7v-2.1h2.1             c0.4,0,0.7-0.3,0.7-0.7v-2.8C16.9,12.3,16.6,12,16.2,12z M15.5,14.8h-2.1c-0.4,0-0.7,0.3-0.7,0.7v2.1h-1.4v-2.1             c0-0.4-0.3-0.7-0.7-0.7H8.5v-1.4h2.1c0.4,0,0.7-0.3,0.7-0.7v-2.1h1.4v2.1c0,0.4,0.3,0.7,0.7,0.7h2.1V14.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskList);
export default __webpack_public_path__ + "static/media/taskList.284d01de155d85c45489a7ba0cc0b8f1.svg";
export { ForwardRef as ReactComponent };